import { createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "screen__lines" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "screen__scanline" }, null, -1)
const _hoisted_3 = { class: "screen__content" }
const _hoisted_4 = {
  key: 0,
  class: "screen__splash"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["screen", $options.classes]),
    onClick: _cache[1] || (_cache[1] = (...args) => ($options.emitClick && $options.emitClick(...args)))
  }, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createBlock(_resolveDynamicComponent($data.binary), {
        ref: "binary",
        onRun: $options.runBinary,
        onBoot: $options.forceShell,
        key: _ctx.instanceKey
      }, null, 8, ["onRun", "onBoot"]))
    ]),
    (_ctx.splash)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("pre", null, _toDisplayString(_ctx.splash), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "screen__sound",
      onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.toggleSound && _ctx.toggleSound(...args)))
    }, [
      _createElementVNode("i", {
        class: _normalizeClass(["fas fa-volume", _ctx.sound ? "fa-volume" : "fa-volume-off"])
      }, null, 2)
    ])
  ], 2))
}